var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8389 13.3333H4.62058C3.9096 13.3333 3.33325 12.7364 3.33325 12L3.3333 4C3.33331 3.26362 3.90966 2.66667 4.62063 2.66667H10.4138C11.1247 2.66667 11.7011 3.26363 11.7011 4.00001V6.66668M12.0229 11.6667L12.6666 12.3334M12.3448 10.3334C12.3448 11.2538 11.6243 12 10.7356 12C9.84688 12 9.12643 11.2538 9.12643 10.3334C9.12643 9.41288 9.84688 8.66669 10.7356 8.66669C11.6243 8.66669 12.3448 9.41288 12.3448 10.3334Z",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.1f171da19effc9e7aa321a03712c6282.svg";
export { ForwardRef as ReactComponent };